const typeRouteHistoriquePei = [
  {
    id: "HISTORIQUE_OPERATIONS",
    libelle: "Historique des opérations",
  },
  {
    id: "RAPPORT_PERSO",
    libelle: "Rapport personnalisé",
  },
];

export const enum TYPE_ROUTE_HISTORIQUE_PEI {
  HISTORIQUE_OPERATIONS = "HISTORIQUE_OPERATIONS",
  RAPPORT_PERSO = "RAPPORT_PERSO",
}

export default typeRouteHistoriquePei;
